export default class Calculator {
	constructor(block) {
		this.calculator = block.querySelector(".calculator-box");

		if (!this.calculator) {
			return;
		}

		this.clientsField = this.calculator.querySelector('[name="clients"]');
		this.revenueField = this.calculator.querySelector('[name="revenue"]');
		this.result = this.calculator.querySelector("span.amount");

		this.clientsField.addEventListener("input", this.handleSlider.bind(this));
		this.calculator.querySelector(".btn").addEventListener("click", () => {
			const roi = this.clientsField.value * this.revenueField.value;
			this.result.innerText = roi.toLocaleString("en-US", {
				maximumFractionDigits: 2,
			});
		});
	}

	handleSlider(e) {
		this.calculator.querySelector(".slider .value").innerText = e.target.value;
	}
}
